import React, { useEffect } from 'react';
import axios from "axios";
import Header from '../Comman/Header';
import { LuSearch, LuRefreshCw } from 'react-icons/lu';
import { Link } from 'react-router-dom';

function MyTickets() {
    const [tickets, setTickets] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [search, setSearch] = React.useState("");
    const username = localStorage.getItem("username");

    const fetchTickets = async () => {
        if (!username) return;

        setLoading(true);
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "support",
                submethod: "getmytickt",
                userAddress: username,
                key: process.env.REACT_APP_KEY,
            });
            console.log('res', res);

            if (res.data?.resCode === 200) {
                setTickets(res.data.tickets || []);
            } else {
                console.error(res.data?.message);
            }
        } catch (err) {
            console.error("API Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, [username]);

    const CSS = `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        .db-scene {
            background: #e8ecf1;
            min-height: 100vh;
            font-family: 'Inter', -apple-system, sans-serif;
            padding: 28px 20px;
            color: #1e293b;
            position: relative;
            overflow-x: hidden;
            perspective: 1600px;
        }

        .db-profile-card {
            position: relative;
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(25px);
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 44px;
            padding: 40px;
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
            margin-bottom: 40px;
        }

        /* --- SEARCH PILL --- */
        .db-search-pill {
            background: rgba(238, 242, 246, 0.5); 
            border-radius: 20px; 
            padding: 12px 24px; 
            border: 1px solid rgba(255, 255, 255, 0.8);
            box-shadow: inset 2px 2px 5px rgba(0,0,0,0.02), 1px 5px 10px rgba(191,201,216,0.1);
            display: flex; 
            align-items: center; 
            gap: 12px;
            flex: 1;
            transition: all 0.3s;
        }
        .db-search-pill:focus-within {
            background: #fff;
            border-color: #006fe3;
            box-shadow: 0 10px 20px rgba(0, 111, 227, 0.05);
        }
        .db-search-input {
            background: transparent;
            border: none;
            outline: none;
            width: 100%;
            font-weight: 700;
            color: #1e293b;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        /* --- REFRESH BTN --- */
        .db-refresh-btn {
            background: #ffffff;
            border-radius: 20px;
            padding: 12px 26px;
            border: 1px solid rgba(255,255,255,0.8);
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-size: 13px;
            color: #1e293b;
            display: flex;
            align-items: center;
            gap: 8px;
            box-shadow: 1px 5px 15px rgba(0,0,0,0.03);
            transition: all 0.3s;
            cursor: pointer;
        }
        .db-refresh-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.05);
        }

        /* --- TABLE STYLES --- */
        .db-table-header {
            font-size: 11px;
            font-weight: 800;
            color: #94a3b8;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            border-bottom: 2px solid #f1f5f9;
            padding-bottom: 20px;
            margin-bottom: 10px;
        }

        .db-table-row {
            padding: 24px 0;
            border-bottom: 1px solid rgba(0,0,0,0.03);
            transition: all 0.3s;
            display: flex;
            align-items: center;
        }
        .db-table-row:hover { background: rgba(255,255,255,0.4); }

        .ticket-id {
            color: #f59e0b;
            font-weight: 800;
            font-size: 13px;
            letter-spacing: 0.5px;
            text-decoration: none;
        }
        .ticket-subject {
            font-weight: 900;
            color: #1e293b;
            font-size: 15px;
            text-transform: uppercase;
            line-height: 1;
            margin-bottom: 4px;
        }
        .ticket-category {
            font-weight: 700;
            color: #94a3b8;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        /* --- PILLS --- */
        .db-pill {
            padding: 6px 16px;
            border-radius: 8px;
            font-size: 11px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            min-width: 80px;
            text-align: center;
            border: 1px solid transparent;
        }
        .pill-low { background: #eff6ff; color: #3b82f6; border-color: #dbeafe; }
        .pill-medium { background: #fffbeb; color: #d97706; border-color: #fef3c7; }
        .pill-high { background: #fef2f2; color: #ef4444; border-color: #fee2e2; }
        .pill-status { background: #f0fdf4; color: #22c55e; border-color: #dcfce7; }

        .ticket-date {
            color: #64748b;
            font-weight: 700;
            font-size: 12px;
        }

        .header-icon-box {
            width: 48px;
            height: 48px;
            background: #fff;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 4px 10px 20px rgba(0,0,0,0.05);
            color: #006fe3;
            font-size: 20px;
        }

        /* RESPONSIVE */
        @media (max-width: 991px) {
            .db-scene { padding: 15px 10px; }
            .db-profile-card { padding: 25px; border-radius: 30px; overflow-x: auto; }
            .db-table-header, .db-table-row { min-width: 800px; }
            .db-refresh-btn { padding: 10px 15px; font-size: 11px; }
        }

        @media (max-width: 576px) {
            .db-search-pill { padding: 8px 15px; }
            .db-search-input { font-size: 12px; }
            .ticket-id { font-size: 11px; }
            .ticket-subject { font-size: 13px; }
        }
    `;
    const filteredTickets = tickets.filter((t) =>
        t?.ticketId?.toLowerCase().includes(search.toLowerCase()) ||
        t?.subject?.toLowerCase().includes(search.toLowerCase())

    );
    console.log('filteredTickets', filteredTickets);

    return (
        <div className="body-bg">
            <style>{CSS}</style>
            <Header />
            <section className="nftmax-adashboard nftmax-show">
                <div className="db-scene" style={{ borderRadius: '29px' }}>
                    <div className="container">

                        {/* Title Header */}
                        <div className="d-flex align-items-center gap-3 mb-2 px-3">
                            {/* <div className="header-icon-box">
                                <LuPlus />
                            </div> */}
                            <div className="text-start">
                                <h1 className="mb-0 fw-black" style={{ fontWeight: 900, color: '#1e293b', fontSize: '26px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Registry Overview</h1>
                                {/* <p className="mb-0 text-uppercase fw-bold opacity-50" style={{ fontSize: '11px', letterSpacing: '1.5px', color: '#64748b' }}>Monitor protocol engagement and resolution status</p> */}
                            </div>
                        </div>

                        {/* Search & Actions Area */}
                        <div className="db-profile-card">
                            <div className="d-flex align-items-center gap-4 mb-5">
                                <div className="db-search-pill">
                                    <LuSearch size={20} style={{ color: '#94a3b8' }} />
                                    <input
                                        type="text"
                                        className="db-search-input"
                                        placeholder="Search tickets..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                                <div className="db-refresh-btn" onClick={fetchTickets}>
                                    <LuRefreshCw /> REFRESH
                                </div>
                            </div>

                            {/* Ticket Table Header */}
                            <div className="row db-table-header px-2">
                                <div className="col-2">Ticket ID</div>
                                <div className="col-4">Subject</div>
                                <div className="col-2 text-center">Priority</div>
                                <div className="col-2 text-center">Status</div>
                                <div className="col-2 text-end">Modified</div>
                            </div>
                            {loading && <div className="text-center py-4">Loading tickets...</div>}

                            {!loading && filteredTickets.length === 0 && (
                                <div className="text-center py-4">No tickets found</div>
                            )}
                            {/* Ticket Rows */}
                            {filteredTickets.map((ticket, idx) => (
                                <div className="row db-table-row px-2" key={idx}>
                                    <div className="col-2">
                                        {ticket?.status?.toLowerCase() === "closed" ? (
                                            <span className="ticket-id text-muted" style={{ cursor: "not-allowed", opacity: 0.6 }}>
                                                {ticket.ticketId}
                                            </span>
                                        ) : (
                                            <Link to={`/support/ticket/${ticket.ticketId}`} className="ticket-id">
                                                {ticket.ticketId}
                                            </Link>
                                        )}
                                    </div>
                                    <div className="col-4 text-start">
                                        <div className="ticket-subject">{ticket.subject}</div>
                                        <div className="ticket-category">{ticket.category}</div>
                                    </div>
                                    <div className="col-2 d-flex justify-content-center">
                                        <div className={`db-pill pill-${ticket.priority?.toLowerCase()}`}>{ticket.priority}</div>
                                    </div>
                                    <div className="col-2 d-flex justify-content-center">
                                        <div className="db-pill pill-status">{ticket.status}</div>
                                    </div>
                                    <div className="col-2 text-end ticket-date">
                                        {new Date(ticket.updatedAt).toLocaleDateString()}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MyTickets;
